import ScheduleManager from './pages/ScheduleManager';
import ScotPage from './pages/ScotPage';
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AccessControlProvider } from './contexts/AccessControlContext';
import Login from './pages/login/Login';
import Sidebar from './components/sidebar/Sidebar';
import Topbar from './components/topbar/Topbar';
import Users from './pages/users/Users';
import CustomersPage from './pages/customers/CustomersPage';
import Pipeline from './pages/sales-pipeline/Pipeline';
import Inbox from './pages/inbox/Inbox';
import ReportsPage from './pages/reports/ReportsPage';
import Dashboard from './pages/dashboard/Dashboard';
import Targets from './pages/targets/Targets';
import SetTargets from './pages/targets/SetTargets';
import SetActuals from './pages/actuals/SetActuals';
import ActivityLog from './pages/activity-log/ActivityLog';
import Enquiries from './pages/enquiries/Enquiries';
import LocalQuotations from './pages/LocalQuotations';
import Products from './pages/products/Products';
import ProtectedRoute from './components/auth/ProtectedRoute';
import './App.css';
import StockPage from './pages/StockPage';
import OutstandingPage from './pages/OutstandingPage';
import PaymentRemindersPage from './pages/payment-reminders/PaymentRemindersPage';
import SalesOrdersPage from './pages/SalesOrdersPage';

// The Customers page still honours ?accountId= and ?contactId=, so carry the query across.
function RedirectWithSearch({ to }) {
  const { search } = useLocation();
  return <Navigate to={{ pathname: to, search }} replace />;
}

function App() {
  const [mobileOpen, setMobileOpen] = useState(false);
  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        {process.env.NODE_ENV === 'development' && (
          <Route path="/dev/payments" element={<PaymentRemindersPage />} />
        )}
        
        {/* Protected Routes */}
        <Route path="/*" element={
          <ProtectedRoute>
            <AccessControlProvider>
              <div className="App min-h-screen flex bg-gray-50">
                <Sidebar mobileOpen={mobileOpen} onMobileClose={() => setMobileOpen(false)} />
                <main className="main-content flex-1 bg-gray-50 overflow-y-auto min-w-0">
                  <Topbar onMenuToggle={() => setMobileOpen(prev => !prev)} />
                  <Routes>
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/users" element={<Users />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/stock" element={<StockPage />} />
                    <Route path="/outstanding" element={<PaymentRemindersPage />} />
                    <Route path="/sales-orders" element={<SalesOrdersPage />} />
                    <Route path="/reports" element={<ReportsPage />} />
                    <Route path="/customers" element={<CustomersPage />} />
                    <Route path="/inbox" element={<Inbox />} />
                    <Route path="/enquiries" element={<Enquiries />} />
                    <Route path="/local-quotations" element={<LocalQuotations />} />
                    
                    <Route path="/sales-pipeline" element={<Pipeline />} />
                    <Route path="/products" element={<Products />} />

                    {/* Merged pages: keep old links and bookmarks working. */}
                    <Route path="/accounts" element={<RedirectWithSearch to="/customers" />} />
                    <Route path="/contacts" element={<RedirectWithSearch to="/customers" />} />
                    <Route path="/customer-history" element={<Navigate to="/customers" replace />} />
                    <Route path="/price-history" element={<Navigate to="/customers" replace />} />
                    <Route path="/meca" element={<Navigate to="/reports" replace />} />
                    <Route path="/demand-forecast" element={<Navigate to="/reports" replace />} />
                    <Route path="/leaderboard" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/targets" element={<Targets />} />
                    <Route path="/targets/set" element={<SetTargets />} />
                    <Route path="/actuals" element={<Navigate to="/reports" replace />} />
                    <Route path="/actuals/set" element={<SetActuals />} />
                    <Route path="/activity-log" element={<ActivityLog />} />
                    
                    
                    <Route path="/schedule" element={<ScheduleManager />} />
              <Route path="/scot" element={<ScotPage />} />
        </Routes>
                </main>
              </div>
            </AccessControlProvider>
          </ProtectedRoute>
        } />
        </Routes>
    </Router>
  );
}

export default App;
